import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
// import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import handlePostRequest from '../utils/requestHandler';
import Form from './Captcha';
import { useSearchParams } from 'react-router-dom';
import { translate } from '../utils/languageMap';
import { SearchResults } from './Delete';
import { Copyright } from './Delete';

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function DeleteWithPhone() {
  const navigate = useNavigate();
  const [first, setFirst] = React.useState(true);
  const [success, setSuccess] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [showCaptcha, setShowCapcha] = React.useState(false);
  const [siteKey, setSiteKey] = React.useState("");
  const [token, setToken] = React.useState(null);
  const [companyId, setCompanyId] = React.useState(null);
  const [accountId, setAccountId] = React.useState(null);
  const [customerId, setCustomerId] = React.useState(null);

  const lang = SearchResults('lang');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    if (first) {
      if (data.get('number') === "") { setError(true) } else {
        const result = await handlePostRequest(`/send-otp/${companyId}`, {
          phoneNumber: data.get('number'),
          token: token,
        });
        if (!result.error) {
          setError(false);
          setFirst(false);
          setToken(null);
          setShowCapcha(false);
          setCustomerId(result?.customerId);
        } else if (result.error === "Captcha required") {
          console.log("1last child");
          setToken(null);
          setShowCapcha(!showCaptcha);
          setSiteKey(result.siteKey);
        } else {
          setError(true)
          console.log("last child");

        }
      }


    } else {
      if (data.get('otp') !== "") {
        const result = await handlePostRequest(`/check-otp/${companyId}`, {
          customerId: customerId,
          otp: data.get('otp'),
        });
        if (!result.error) {
          setSuccess(true);
          setError(false)
        } else {
          setError(true)
        }
      } else {
        setError(true)
      }
    }
  }; // Add closing parenthesis here


  const checkCompany = async () => {
    const url = new URL(window.location.href)

    const segments = url.pathname.split('/').filter(Boolean); // filter(Boolean) is used to remove empty strings
    setAccountId(segments[segments.length - 3]);
    setCompanyId(segments[segments.length - 2])
  }




  React.useEffect(() => {
    checkCompany()
  }, []);

  const uri = "https://miro.medium.com/v2/resize:fit:1400/0*nWb6nvGBuNVcMZM0"

  return (
    <ThemeProvider theme={defaultTheme}>
      <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={6}
          sx={{
            backgroundImage: `url(${uri})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >

            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            </Avatar>
            <Typography component="h1" variant="h5">
              {translate("Forgot password", lang)}
            </Typography>
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>

              <TextField
                margin="normal"
                required
                fullWidth
                id="number"
                label={translate("Phone number", lang)}
                name="number"
                autoComplete="number"
                autoFocus
              />
              {!first && <TextField
                margin="normal"
                required
                fullWidth
                name="otp"
                label={translate("Code from message", lang)}
                type="otp"
                id="otp"
              />}
              {showCaptcha && <Form siteKey={siteKey} token={token} setToken={setToken} />}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                {first ? translate("Get code", lang) : translate("Delete", lang)}
              </Button>
              <Grid container>
                {success && <Typography variant="body2" color={"green"}>
                  {translate("Successfully removed", lang)}
                </Typography>}
                {error && <Typography variant="body2" color={"red"}>
                  {translate("Check the data is correct", lang)}
                </Typography>}
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
